//shared/components/chat/MessageInput.js
import React, { useState, useRef } from "react";
import { TextField, IconButton, Paper, Popover } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
// import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import EmojiPicker from "emoji-picker-react";

const MessageInput = ({ onSend, disabled }) => {
  const [message, setMessage] = useState("");
  const [emojiAnchor, setEmojiAnchor] = useState(null);
  const inputRef = useRef(null);

  const handleEmojiClick = (emojiData) => {
    setMessage((prev) => prev + emojiData.emoji);
    inputRef.current?.focus();
  };

  const handleSend = () => {
    if (message.trim()) {
      onSend(message);
      setMessage("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Paper
      sx={{
        p: 2,
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        gap: 1,
        alignItems: "flex-end",
      }}
      elevation={3}
    >
      <IconButton
        size="small"
        color="primary"
        onClick={(e) => setEmojiAnchor(e.currentTarget)}
      >
        <EmojiEmotionsIcon />
      </IconButton>

      <Popover
        open={Boolean(emojiAnchor)}
        anchorEl={emojiAnchor}
        onClose={() => setEmojiAnchor(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <EmojiPicker
          onEmojiClick={handleEmojiClick}
          width={300}
          height={400}
          searchPlaceHolder="Pesquisar emoji..."
          previewConfig={{ showPreview: false }}
        />
      </Popover>

      {/* <IconButton size="small" color="primary">
        <AttachFileIcon />
      </IconButton> */}

      <TextField
        inputRef={inputRef}
        fullWidth
        multiline
        maxRows={4}
        placeholder={
          disabled ? "Aguarde a resposta..." : "Digite uma mensagem..."
        }
        disabled={disabled}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyPress}
        variant="outlined"
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 3,
          },
        }}
      />

      <IconButton
        color="primary"
        onClick={handleSend}
        disabled={!message.trim() || disabled}
        sx={{
          bgcolor: "primary.main",
          color: "white",
          "&:hover": {
            bgcolor: "primary.dark",
          },
          "&:disabled": {
            bgcolor: "grey.300",
          },
        }}
      >
        <SendIcon />
      </IconButton>
    </Paper>
  );
};

export default MessageInput;
